export default __webpack_public_path__ + "static/media/vc-microphone.d91f0d9f.png";